import { useEffect, useState } from "react";
import { Color } from "../Color";
import { calcAPCA } from "apca-w3";
import { Icon } from "./Icon";
import { calculateLcValues } from "../../../../utils/calcLC";

export const APCAContrast = ({ check, bg, fg, typo, textUse, colorUse }) => {
	const [use, setUse] = useState(0)

	useEffect(() => {
		const val = Math.floor(Math.abs(calcAPCA(fg, bg)))
		const { size, ratios, weight } = typo.APCA
		const lcValues = calculateLcValues(size, ratios, weight)
		setUse(lcValues.reduce((u, v) => val >= v ? u + 1 : u, 0))
	}, [typo, fg, bg, colorUse])

	if (use >= textUse) {
		return (
			<tr>
				<th>
					<Color item={check} size="s"></Color>
				</th>
				<td style={{'color': fg, 'backgroundColor': bg}}>
					<span style={typo.style}>
						{typo.label}
					</span>
				</td>
				<td><Icon index={use}></Icon></td>
				<td>{Math.floor(Math.abs(calcAPCA(fg, bg)))}</td>
			</tr>
		)
	}
}
